import * as yup from 'yup';

const ipv4WithPortRegex = /^((?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d):(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]\d{4}|[1-9]\d{0,3})$/;

export const createStationSchema = yup.object({
  name: yup.string().required('Đây là trường bắt buộc'),
  code: yup.string().required('Đây là trường bắt buộc'),
  address: yup.string().required('Đây là trường bắt buộc'),
  longitude: yup
    .number()
    .nullable()
    .typeError('Kinh độ phải là số hợp lệ')
    .min(-180, 'Kinh độ phải lớn hơn hoặc bằng -180')
    .max(180, 'Kinh độ phải nhỏ hơn hoặc bằng 180'),
  latitude: yup
    .number()
    .nullable()
    .typeError('Vĩ độ phải là số hợp lệ')
    .min(-90, 'Vĩ độ phải lớn hơn hoặc bằng -90')
    .max(90, 'Vĩ độ phải nhỏ hơn hoặc bằng 90'),
  type: yup.string().nullable(),
  dataLoggerAddress: yup
    .string()
    .nullable()
    .matches(ipv4WithPortRegex, 'Địa chỉ IP hoặc port không hợp lệ'),
  smsWarning: yup.array().of(
    yup.string().matches(
      /^0[1-9]{1}[0-9]{8}$|\+\d{1,3}\s\d{4,14}$/,
      'Số điện thoại không hợp lệ'
    )).default([])
    .test(
      'no-duplicates',
      'Số điện thoại không được trùng lặp',
      (value) => {
        if (!value) return true;
        const unique = new Set(value);
        return unique.size === value.length;
      }
    ),
  emailWarning: yup.array().of(yup.string()).default([])
    .test(
      'no-duplicates',
      'Email không được trùng lặp',
      (value) => {
        if (!value) return true;
        const unique = new Set(value);
        return unique.size === value.length;
      }
    ),
  telegramWarning: yup.string().nullable(),
  galaryFileIds: yup.array().of(yup.number()).default([]),
  attachmentFileIds: yup.array().of(yup.number()).default([]),
});

export const updateStationSchema = yup.object({
  id: yup.number().required('Đây là trường bắt buộc'),
  name: yup.string().required('Đây là trường bắt buộc'),
  code: yup.string().required('Đây là trường bắt buộc'),
  address: yup.string().required('Đây là trường bắt buộc'),
  longitude: yup
    .number()
    .nullable()
    .typeError('Kinh độ phải là số hợp lệ')
    .min(-180, 'Kinh độ phải lớn hơn hoặc bằng -180')
    .max(180, 'Kinh độ phải nhỏ hơn hoặc bằng 180'),
  latitude: yup
    .number()
    .nullable()
    .typeError('Vĩ độ phải là số hợp lệ')
    .min(-90, 'Vĩ độ phải lớn hơn hoặc bằng -90')
    .max(90, 'Vĩ độ phải nhỏ hơn hoặc bằng 90'),
  type: yup.string().nullable(),
  dataLoggerAddress: yup
    .string()
    .nullable()
    .matches(ipv4WithPortRegex, 'Địa chỉ IP hoặc port không hợp lệ'),
  smsWarning: yup.array().of(
    yup.string().matches(
      /^0[1-9]{1}[0-9]{8}$|\+\d{1,3}\s\d{4,14}$/,
      'Số điện thoại không hợp lệ'
    )).default([])
    .test(
      'no-duplicates',
      'Số điện thoại không được trùng lặp',
      (value) => {
        if (!value) return true;
        const unique = new Set(value);
        return unique.size === value.length;
      }
    ),
  emailWarning: yup.array().of(yup.string()).default([])
    .test(
      'no-duplicates',
      'Email không được trùng lặp',
      (value) => {
        if (!value) return true;
        const unique = new Set(value);
        return unique.size === value.length;
      }
    ),
  telegramWarning: yup.string().nullable(),
  galaryFileIds: yup.array().of(yup.number()).default([]),
  attachmentFileIds: yup.array().of(yup.number()).default([]),
});
